import PropTypes from 'prop-types';

function HeaderTitle({ pathData, channelUser }) {
  return (
    <div>
      {pathData?.title && <span className="font-bold">{pathData.title}</span>}
      {pathData?.channelDetail && <span className="font-bold">{channelUser?.channelName}</span>}
    </div>
  );
}

HeaderTitle.propTypes = {
  pathData: PropTypes.shape({
    title: PropTypes.string,
    channelDetail: PropTypes.bool,
  }).isRequired,
  channelUser: PropTypes.shape({
    channelName: PropTypes.string,
  }),
};

export default HeaderTitle;
